import * as SharedActions from './shared.actions';
import { detectScreenSize } from './utilites/screenSizeDetector';

export interface ScreenSize {
  exact: Breakpoints;
  exactOrBiggerThan: Breakpoints;
  exactOrLowerThan: Breakpoints;
}

export interface Breakpoints {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
}

export interface State {
  currentPage: string;
  isMobile: boolean;
  screenSize: ScreenSize;
}

const initialBreakpoints: Breakpoints = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
};

const initialState: State = {
  currentPage: '',
  isMobile: true,
  screenSize: {
    exact: { ...initialBreakpoints },
    exactOrBiggerThan: { ...initialBreakpoints },
    exactOrLowerThan: { ...initialBreakpoints },
  }
};

export function SharedReducer(
  state: State = initialState,
  action: SharedActions.SharedActions
) {
  switch (action.type) {
    case SharedActions.CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };
    case SharedActions.IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload
      };
    case SharedActions.DETECT_SCREEN_SIZE:
      return {
        ...state,
        screenSize: { ...detectScreenSize() }
      };
    default:
      return state;
  }
}
